import * as SelfEnrollActions from './SelfEnroll.action';


export interface State {
  email: string;
  emailTimestamp: number;
}
const initialState: State = {
  email: '',
  emailTimestamp: null
};

export function SelfEnrollReducer(state = initialState, action: SelfEnrollActions.SelfEnrollActions) {
  switch (action.type) {
    case SelfEnrollActions.SIGN_ESIGN:
      return {
        ...state,
        email: action.payload.email,
        emailTimestamp: action.payload.timestamp
      };
    default:
      return state;
  }
}